import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ProvidehttpService } from '../providehttp.service';
import { FieldComponent } from '../field/field.component';
import { ServiceStock } from '../service-stock.service';

@Component({
  selector: 'app-amount',
  templateUrl: './amount.component.html',
  styleUrls: ['./amount.component.css']
})
export class AmountComponent extends FieldComponent implements OnInit {

  @Input('displayCurrCode') displayCurrCode : boolean = false;

  @Input('minValue') minValue: number;
  @Input('maxValue') maxValue: number;
  @Input('maxLength') maxLength: number;
  @Input('minLength') minLength: number;
  @Input('DecimalLength') DecimalLength :number=2;
  
  @Input('numberToWord') numberToWord: boolean = true;
  @Input('multiCurrency') multiCurrency: boolean = true;
  @Input('multiCurrencyData') multiCurrencyData = [{symbol:'₹', code:'INR'}, {symbol:'$', code:'USD'},{symbol:'د.ا', code:'JOD'}];

  currencyCode='INR';
  languageCode='en-US';

  numberInWord: string;

  private dg = ['zero','one','two','three','four','five','six','seven','eight','nine'];
  private tn = ['ten','eleven','twelve','thirteen', 'fourteen','fifteen','sixteen','seventeen','eighteen','nineteen'];
  private tw = ['twenty','thirty','forty','fifty','sixty','seventy','eighty','ninety'];
  private th = ['','thousand','million', 'milliard','billion'];
  
  constructor(services : ServiceStock) {
    super(services);
  }

  private toWord(num){
    var resultString = "";
    var s = num.toString();
    s = s.replace(/[\, ]/g,'');
    if (s != parseFloat(s)) resultString = 'not a number';
    
    var x = s.indexOf('.'); 
    if (x == -1) x = s.length; 
    if (x > 15) resultString = 'too big';
    
    var n = s.split('');
    var str = '';
    var sk = 0;
    var i = 0;
    for(i;i<x;i++){
      if((x-i)%3==2) {
        if (n[i] == '1') {
          str += this.tn[Number(n[i+1])] + ' '; 
          i++; 
          sk=1;
        } else if (n[i]!=0) {
          str += this.tw[n[i]-2] + ' ';
          sk=1;
        }
      } else if (n[i]!=0){
        str += this.dg[n[i]] +' '; 
        if ((x-i)%3==0) str += 'hundred ';
        sk=1;
      }
      if ((x-i)%3==1){
        if (sk) str += this.th[(x-i-1)/3] + ' ';
        sk=0;
      }
    }
    
    if (x != s.length) {
      var y = s.length; 
      str += 'point ';
      for (var z=x+1; z<y; z++) {
        str += ' ' + this.dg[n[z]];
      }
    }
    
    resultString = str;
    
    return resultString;
  }

  allowNumbersOnly(event) {
    if (event.key > 0 || event.key < 9 || event.key == 'ArrowRight' || event.key == 'ArrowLeft' || event.key == 'Backspace' || event.key == 'Delete' || event.key == 'Tab') {
    }
    else if (event.key == "." || event.key == ",") {
    } else {
      event.preventDefault();
    }
  }

  setFormatOptions(Json){ 
    if(Json.currencyCode)
    this.currencyCode=Json.currencyCode;
    if(Json.languageCode)
    this.languageCode=Json.languageCode;
    if(Json.DecimalLength)
    this.DecimalLength=Json.DecimalLength;
    if (this.value) {
      this.isOnFocus = false;
      this.value = this.additionalInfo;
      this.additionalInfo = this.formatAmount(+this.value , this.languageCode , this.DecimalLength);
    }
  }

  formatAmount(number , languageCode , minFraction) {
    return number.toLocaleString(languageCode, { minimumFractionDigits: minFraction});
  }

  onBlur(){
    this.isOnFocus = false;
    if (this.value) {
      this.additionalInfo = this.formatAmount(+this.value , this.languageCode , this.DecimalLength);
    }
    this.blur.emit(this.value);
  }

  onChange() {
    this.value = this.additionalInfo;
    this.change.emit();
    if (this.value) {
      this.additionalInfo = this.formatAmount(+this.value , this.languageCode , this.DecimalLength);
    }
  }

  onChangeCurrency(value, event=undefined){
    this.currencyCode = value;
  }

    async validateValue(value, event=undefined): Promise<number> {
      var totalErrors: number = 0;
      totalErrors+=this.onNumberInput(value, event);
      if(!totalErrors && this.numberToWord) this.numberInWord = this.toWord(value);
      return totalErrors;
    }
  
    onNumberInput(value: number, event?): number{
      var totalErrors: number = 0;
      value = +value;
      if(this.minValue && value<this.minValue){
        this.setError("Value should be greater than "+ this.minValue);
        totalErrors++;
      }else if(this.maxValue && value>this.maxValue){
          this.setError("Value should be less than "+ this.maxValue);
          totalErrors++;
      }else if((this.DecimalLength && this.countDecimals(value)>=this.DecimalLength)){
        if(event){
          event.target.value = value.toFixed(this.DecimalLength);
          this.value = value.toFixed(this.DecimalLength);
        }else{
          this.setError("Maximum "+ this.DecimalLength + " decimal are allowed");
          totalErrors++;
        }
      }
      else{
        this.clearError();
      }
      return totalErrors;
    }
  countDecimals(value) {
      if(Math.floor(value) === value) return 0;
      return value.toString().split(".")[1].length || 0; 
  }
  isNumberKey(event) {
    var charCode = event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  setValue(value, additionalInfo = undefined) {
    this.value = value;
    if (value) {
      this.numberInWord = this.toWord(value);
      let inputMap = new Map();
      inputMap.set('IP_AMT', value);
      if (additionalInfo) {
        this.additionalInfo = additionalInfo;
      } else {
          this.additionalInfo =this.formatAmount(+this.value , this.languageCode , this.DecimalLength);
      }
    }
    this.passNewValue(this.value);
  }

  fieldReset(){
    if(this.numberToWord) this.numberInWord = '';
  }

  onFocus() {
    this.additionalInfo = this.value;
    this.isOnFocus = true;
    this.clearError();
  }
  ngOnInit() { }

}
